<template>
  <div class="navbar">
    <img v-src="logo" :key="logo" class="logo" @click="enterCustoemBoard" />
    <div class="nav-title">
      系统设置
    </div>
    <div class="back-home text-nowrap" @click="enterHome">返回首页</div>
    <div class="go-out text-nowrap" @click="enterLogin">退出系统</div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    navIndex: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["logo", "crm"]),
  },
  mounted() {},
  methods: {
    enterHome() {
      this.$router.replace({
        path: "/",
      });
    },
    enterLogin() {
      this.$confirm("退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var loading = Loading.service({
            target: document.getElementById("#app"),
          });
          this.$store
            .dispatch("LogOut")
            .then(() => {
              loading.close();
              location.reload();
            })
            .catch(() => {
              loading.close();
              location.reload();
            });
        })
        .catch(() => {});
    },

    /**
     * 有客户权限点击logo 进入仪表盘
     */
    enterCustoemBoard() {
      if (this.crm) {
        this.$router.push("/crm/workbench");
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@media screen and (max-width: 768px) {
  .navbar {
    width: 100vw;
    box-sizing: border-box;
    height: 8vw;
    min-height: 8vw;
    display: flex;
    align-items: center;
    padding: 0 2.6667vw 0 2.6667vw;
    background-color: white;
    .logo {
      width: 20vw;
      height: 5.3333vw;
      display: block;
      flex-shrink: 0;
      margin-right: 2vw;
      cursor: pointer;
    }
    .nav-title {
      flex: 1;
      font-size: 2.1333vw;
      color: #333333;
    }
    .back-home {
      width: 14.6667vw;
      height: 4.8vw;
      line-height: 4.8vw;
      background-color: #2362fb;
      border-radius: 1.0667vw;
      text-align: center;
      color: #fff;
      font-size: 1.8667vw;
      margin-right: 1.3333vw;
      cursor: pointer;
    }
    .go-out {
      width: 14.6667vw;
      height: 4.8vw;
      line-height: 4.8vw;
      background-color: #c2c2c2;
      border-radius: 1.0667vw;
      text-align: center;
      color: #fff;
      font-size: 1.8667vw;
      cursor: pointer;
    }
  }
}
@media screen and (min-width: 769px) {
  .navbar {
    height: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    padding: 0 60px 0 30px;
    background-color: white;
    .logo {
      width: 150px;
      height: 40px;
      display: block;
      flex-shrink: 0;
      margin-right: 60px;
      cursor: pointer;
    }
    .nav-title {
      flex: 1;
      font-size: 16px;
      color: #333333;
    }
    .back-home {
      width: 94px;
      height: 36px;
      line-height: 36px;
      background-color: #2362fb;
      border-radius: 3px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin-right: 10px;
      cursor: pointer;
    }
    .go-out {
      width: 94px;
      height: 36px;
      line-height: 36px;
      background-color: #c2c2c2;
      border-radius: 3px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
